import React from "react";

import { Box, StyledLink } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { gotoUrl } from "utils/helpers";
import get from "lodash/get";

const NavigateLink = props => {
  const { enable = true, targetRoute = "", label, themeColors, style } = props;
  const navigateTo = () => {
    if (!enable) return;
    gotoUrl(targetRoute);
  };

  const textColor = style?.textColor || get(themeColors, "text");
  const marginTop = style?.marginTop || [24, 36];
  return (
    <Box mt={marginTop} sx={{ textAlign: "center" }}>
      <StyledLink onClick={navigateTo} disabled={!enable} color={textColor}>
        <FormattedMessage id={label} />
      </StyledLink>
    </Box>
  );
};

export default NavigateLink;
